import styled from "styled-components";

const Style = styled.div`
  display: flex;

  .image-cont {
    padding: 0px var(--size-lg);
    min-height: 272px;
    position: relative;
    background-repeat: no-repeat !important;
    background-size: cover !important;
    background-position: center !important; 

    .mask {
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0px;
      left: 0px;
      opacity: 0.8;
      background: linear-gradient(90deg, #333131 8.85%, rgba(88, 83, 83, 0.39) 56.25%, rgba(255, 255, 255, 0.0) 100%);
    }

    .product-logo {
      width: 120px;
      height: unset;
      top: var(--size-lg);
      left: var(--size-lg);
      position: absolute;
    }
  }

  .info-cont {
    padding: 0px var(--size-lg);

    .item {
      display: flex;
      padding: var(--size-lg) 0px;
      border-bottom: 1px solid var(--base-gray-40);

      &:last-of-type {
        border-bottom: 0px;
      }

      label {
        font-weight: 500;
        color: var(--base-gray-80);

        &.value {
          color: var(--base-gray-90);
        }
      }
    }
  }
`;

export default Style;
